import { useEffect, useState } from 'react';
export const useIsComponentRendered = (id) => {
    const [rendered, setRendered] = useState(false);
    const checkIfComponentRendered = () => {
        const element = document.getElementById(id);
        return !!element;
    };
    useEffect(() => {
        const interval = setInterval(() => {
            const isRendered = checkIfComponentRendered();
            if (isRendered) {
                setRendered(true);
                clearInterval(interval);
            }
        }, 100);
        return () => clearInterval(interval);
    }, [id]);
    return rendered;
};
